import React, {Component} from 'react';
import {connect} from 'react-redux';
import {message} from 'antd';

import Property from './Property';
import {
    fetchProperties,
    storeProperty,
    updateProperty,
    lookupLocation,
    fetchContractors,
    clearLookupLocation,
    retireProperty,
    uploadPropertyDocument,
    deletePropertyDocument
} from '../../../actions';

class PropertyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverErrors: null
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const {property} = nextProps;
        if (!property) return null;

        if (property.error) {
            return {serverErrors: property.error}
        }
        if (!property.error && prevState.serverErrors) {
            return {serverErrors: null}
        }
        return null;
    }
    static notifySuccess() {
        message.success('Successfully updated');
    }
    static notifyError(errors) {
        const errs = typeof errors === 'string' ? errors : Object.keys(errors).map(key => errors[key].map((e, i) => <span key={i}>{e}</span>));
        message.error(errs);
    }
    handlePostSubmit(redirect = true) {
        const {state: {serverErrors}, props: {history, clearLookupLocation}} = this;
        if (!serverErrors) {
            PropertyContainer.notifySuccess();
            clearLookupLocation();
            if (redirect) setTimeout(() => history.goBack(), 100);
            return;
        }

        const {res: {errors, message}} = serverErrors;
        PropertyContainer.notifyError(errors || message);
    }
    componentDidMount() {
        const {
            match: {params: {property: id}},
            landlord,
            fetchProperties,
            property,
            fetchContractors
        } = this.props;

        fetchContractors(landlord);
        if (!id) return;
        !property && fetchProperties(landlord);
    }
    render() {
        const {
            storeProperty,
            updateProperty,
            landlord,
            history,
            property,
            lookupLocation,
            location,
            contractors,
            retireProperty,
            uploadPropertyDocument,
            deletePropertyDocument
        } = this.props;
        const onSubmit = (values) => {
            const fn = !property || property.draft ? storeProperty : updateProperty;
            const args = !property || property.draft ? [landlord, values] : [landlord, property.id, {...values, id: property.id}];
            return fn(...args).then(() => this.handlePostSubmit());
        };
        const loc = !property ? location : {lat: property.latitude, lng: property.longitude};
        const onPostcodeChange = postcode => {
            if (postcode.length >= 5) {
                return lookupLocation(postcode);
            }
        };
        const onRetire = () => {
            if (!property || property.draft) return Promise.resolve();
            return retireProperty(landlord, property.id).then(() => this.handlePostSubmit(false));
        };

        const generateUrl = (doc) => {
            return `/api/landlord/${landlord}/property/${property.id}/document/${doc}`;
        };
        const onUpload = (formData) => {
            return uploadPropertyDocument(landlord, property.id, formData);
        };
        const onDelete = doc => {
            return deletePropertyDocument(landlord, property.id, doc);
        };
        return <Property
            property={property}
            contractors={contractors}
            onSubmit={onSubmit}
            onRetire={onRetire}
            location={loc}
            onPostcodeChange={onPostcodeChange}
            onCancel={() => history.goBack()}
            onUpload={onUpload}
            onDelete={onDelete}
            generateUrl={generateUrl}
        />;
    }
}

const mapStateToProps = (state, ownProps) => {
    // id exists for edit component
    const {match: {params: {property: id}}} = ownProps;
    const property = state.landlord.properties.active.data.find(b => id ? (b.id === +id) : b.draft);
    const {latitude: lat, longitude: lng} = state.lookup.location;

    return {
        landlord: state.me.application.id,
        location: {lat, lng},
        property,
        contractors: state.landlord.contractors.data
    };
};
export default connect(mapStateToProps, {
    storeProperty,
    updateProperty,
    lookupLocation,
    fetchProperties,
    fetchContractors,
    clearLookupLocation,
    retireProperty,
    uploadPropertyDocument,
    deletePropertyDocument
})(PropertyContainer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/property/PropertyContainer.js